import {Component, EventEmitter, Input, OnInit, Output} from "@angular/core";

@Component({
  selector: "field-set-min-length",
  templateUrl: "./field-set-min-length.component.html",
  styles: [],
})
export class FieldSetMinLengthComponent {
  @Input() public fieldOptions: any = {validate: {minLength: 0}};
  @Output() public dataChanged = new EventEmitter();

  public dataChangedEvent(event) {
    this.dataChanged.emit(event);
  }
}
